import React from 'react';
import keys from '../images/keys.jpg';

const Landlords = () => {
  return (
    <section className="about landlords">
      <div className="container">
        <h2 className="about__title" style={{ textAlign: 'left' }}>Landlords</h2>
        <div className="about__content">
          <div className="about__text">
            <p className="about__description">
              Fix It All has years of experience in managing
              property portfolios on behalf of landlords.
            </p>
            <p className="about__description">
              Whatever you need in terms of maintaining your
              property, Fix It All can provide you with it.
            </p>
          </div>
          <div className="about__image-container">
            <img
              src={keys}
              alt="Property keys"
              className="about__image"
              style={{ maxHeight: '300px', width: 'auto' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Landlords;
